import React, { useEffect, useContext, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';

function PagesRegister() {
	const context = useContext(AppSettings);
	const [redirect, setRedirect] = useState(false);
	const months = [
    'January', 'February', 'March', 'April', 'May', 'June', 
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const years = Array.from({ length: 101 }, (_, i) => new Date().getFullYear() - i);
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);
	
	function handleSubmit(event) {
		event.preventDefault();
		
		setRedirect(true);
  }
  
	if (redirect) {
		return <Navigate to='/' />;
	}
	return (
		<div className="register">
			<div className="register-content">
				<form onSubmit={handleSubmit}>
					<h1 className="text-center">Sign Up</h1>
					<p className="text-body text-opacity-50 text-center mb-4">One Admin ID is all you need to access all the Admin services.</p>
					<div className="mb-4">
						<label className="form-label" htmlFor="">Name <span className="text-danger">*</span></label>
						<input type="text" className="form-control form-control-lg fs-14px" placeholder="e.g John Smith" defaultValue="" />
					</div>
					<div className="mb-4">
						<label className="form-label" htmlFor="">Email Address <span className="text-danger">*</span></label>
						<input type="text" className="form-control form-control-lg fs-14px" placeholder="username@address.com" defaultValue="" />
					</div>
					<div className="mb-4">
						<label className="form-label" htmlFor="">Password <span className="text-danger">*</span></label>
						<input type="password" className="form-control form-control-lg fs-14px" defaultValue="" />
					</div>
					<div className="mb-4">
						<label className="form-label" htmlFor="">Confirm Password <span className="text-danger">*</span></label>
						<input type="password" className="form-control form-control-lg fs-14px" defaultValue="" />
					</div>
					<div className="mb-4">
						<label className="form-label" htmlFor="">Country <span className="text-danger">*</span></label>
						<select className="form-control form-control-lg fs-14px">
							<option>United States</option>
						</select>
					</div>
					<div className="mb-4">
						<label className="form-label" htmlFor="">Gender <span className="text-danger">*</span></label>
						<select className="form-control form-control-lg fs-14px">
							<option>Female</option>
						</select>
					</div>
					<div className="mb-4">
						<label className="form-label" htmlFor="">Date of Birth <span className="text-danger">*</span></label>
						<div className="row">
							<div className="col-6">
								<select className="form-select form-select-lg fs-14px">
									<option>Month</option>
									{months.map((month) => (
										<option key={month} defaultValue={month.toLowerCase()}>
											{month}
										</option>
									))}
								</select>
							</div>
							<div className="col-3">
								<select className="form-select form-select-lg fs-14px">
									<option>Day</option>
									{days.map((day) => (
										<option key={day} defaultValue={day}>
											{day}
										</option>
									))}
								</select>
							</div>
							<div className="col-3">
								<select className="form-select form-select-lg fs-14px">
									<option>Year</option>
									{years.map((year) => (
										<option key={year} defaultValue={year}>
											{year}
										</option>
									))}
								</select>
							</div>
						</div>
					</div>
					<div className="mb-4">
						<div className="form-check">
							<input className="form-check-input" type="checkbox" defaultValue="" id="customCheck1" />
							<label className="form-check-label" htmlFor="customCheck1">I have read and agree to the <a href="#/">Terms of Use</a> and <a href="#/">Privacy Policy</a>.</label>
						</div>
					</div>
					<div className="mb-3">
						<button type="submit" className="btn btn-theme btn-lg d-block w-100 mb-3">SIGN UP</button>
					</div>
					<div className="text-body text-opacity-50 text-center">
						Already have an Admin ID? <Link to="/page/login">Sign In</Link>
					</div>
				</form>
			</div>
		</div>
	)
}

export default PagesRegister;